<template>
  <div class="iqos-grid">
    <div class="iqos-column">
      <IQOS :title="$t('marketplace.loyalty')" :enabled="is_active">
        <div class="mt-16 gap-row-xs">
          <BaseSelect
            :placeholder="$t('loyalty_view.placeholder')"
            v-model.number="loyalty.cashback_percent"
            @blur="onEditFinish"
            v-if="is_active"
          >
            <option v-for="n in 100" :value="n" :key="n">{{ n }}%</option>
          </BaseSelect>
          <p
            class="iqos-comment qrw-paragraph-md"
            :class="{
              'pt-0': !is_active,
            }"
          >
            {{ $t("loyalty_view.desc") }}
          </p>
        </div>

        <template #actions>
          <IQOSToggle v-model="is_active" />
        </template>
      </IQOS>
    </div>
    <div class="iqos-column">
      <IQOS :title="$t('loyalty_view.stats')" enabled>
        <div class="stat-row mt-16">
          <div class="stat-row-col">
            <div class="label qrw-label-sm v1-grey-6-color ">{{ $t("loyalty_view.bonuses_total") }}</div>
            <div class="number qrw-heading-md v1-grey-3-color">{{summary.collected_total || 0}} {{ currency.symbol }}</div>
          </div>
          <div class="stat-row-col">
            <div class="label qrw-label-sm v1-grey-6-color">{{ $t("loyalty_view.bonuses_used") }}</div>
            <div class="number qrw-heading-md v1-grey-3-color">{{summary.spent_total || 0}} {{ currency.symbol }}</div>
          </div>
        </div>
      </IQOS>
    </div>
  </div>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSToggle from "@/components/IQOSToggle.vue";

import BlackSelect from "@/components/BlackSelect.vue";

import StatsAPI from '@/api/stats'

export default {
  data() {
    return {
      loyalty: {
        cashback_percent: null,
        terms_agreed: false,
      },

      summary: {
        collected_total: 0,
        spent_total: 0
      },

      is_active: false,
    };
  },
  watch: {
    is_active() {
      if (!this.is_active) {
        this.loyalty.cashback_percent = 0;
        this.loyalty.terms_agreed = false;
        this.onEditFinish();
      }
    },
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.setInitialValue();
    },
    onEditFinish() {
      if (this.loyalty.cashback_percent) {
        this.loyalty.terms_agreed = true;
      }

      this.$store.commit("setLoyaltySettings", this.loyalty);
      this.$store.dispatch("saveCafe");

      // this.editing = false;

      this.$store.dispatch("auditlog/write", {
        type: "loyalty_change",
        payload: {
          percent: this.loyalty.cashback_percent,
        },
      });
    },
    setInitialValue() {
      if (this.cafe.loyalty) {
        this.loyalty.terms_agreed = !!this.cafe.loyalty.cashback_percent;
        this.loyalty.cashback_percent = this.cafe.loyalty.cashback_percent;
      }

      this.is_active = this.loyalty.cashback_percent > 0;
    },
    fetchSummary() {
      StatsAPI.computeLoyaltySummary(this.cafe._id).then((data) => {
        this.summary = {
          collected_total: data.collected_total.toFixed(2),
          spent_total: data.spent_total.toFixed(2)
        };
      }).catch((error) => {
        console.log(error);
      })
    }
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    },
    cafe() {
      return this.$store.state.cafe;
    },
  },
  mounted() {
    this.setInitialValue();

    this.fetchSummary();
  },
  components: {
    IQOS,
    IQOSToggle,
    BlackSelect,
  },
};
</script>

<style scoped>
.label {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
  width: 100%;
}
.number {
  font-size: 3.3333333333333335vh;
  line-height: 3.888888888888889vh;
  color: #ededed;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.number span {
  color: #908f8d;
}
.stat-row {
  display: flex;
}
.stat-row .stat-row-col {
  width: 48%;
  margin-right: 2.22vh;
}
.stat-row .stat-row-col:last-child {
  margin-right: 0;
}
.iqos-transparent .container-box {
  background: transparent;
}
</style>
